<ion-grid *ngIf="searchOptions">
  <ion-row>
    <ion-col size="auto">
      <ion-button (click)="triggerPopover($event)">
        <ion-icon slot="icon-only" *ngIf="selectedOption" [name]="selectedOption.icon"></ion-icon>
      </ion-button>
      <ion-popover #popoverDom reference="event">
        <ng-template>
          <ion-list *ngIf="searchOptions.length > 0">
            <ion-item *ngFor="let item of searchOptions; let i = index" (click)="clickOption(i)">
              <ion-icon [name]="item.icon" slot="start"></ion-icon>
              <ion-label>{{ item.label }}</ion-label>
            </ion-item>
          </ion-list>
          <ion-item *ngIf="searchOptions.length === 0">
              <ion-label>All search options set</ion-label>
          </ion-item>
        </ng-template>
      </ion-popover>
    </ion-col>
    <ion-col size="auto">
      <ion-input placeholder="Search" [formControl]="valueControl"> </ion-input>
    </ion-col>
  </ion-row>
</ion-grid>
